import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { map, Observable, switchMap } from 'rxjs';
import { PageData } from '../shared/page-data.model';
import { GET_SCAN_PROJECT_URL } from '../utils/get-scan-project-url';
import { ScandataFile } from './scandata-file.model';
import { PatchScandataModel } from './scandata.actions';
import { ScandataModel } from './scandata.models';

const FILE_PAGE_SIZE_LIMIT = 500;

@Injectable({
  providedIn: 'root',
})
export class ScandataFileService {
  private readonly getScanProjectUrl$ = inject(GET_SCAN_PROJECT_URL);

  constructor(
    private store: Store,
    private http: HttpClient,
  ) {}

  loadScandataFiles(scan: ScandataModel): Observable<ScandataModel> {
    return this.getScanProjectUrl$(
      `/pointclouds/${scan.id}/files?pageIndex=0&pageSize=${FILE_PAGE_SIZE_LIMIT}`,
    ).pipe(
      switchMap((url) => this.http.get<PageData<ScandataFile>>(url)),
      map((pageData) => pageData.items),
      switchMap((files) => {
        return this.store
          .dispatch(new PatchScandataModel({ ...scan, files }))
          .pipe(map(() => scan));
      }),
    );
  }
}
